var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288,
    height: 288,
    viewBox: "0 0 32 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "color000 svgShape",
    "data-name": "Group 35012",
    transform: "translate(-1272)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 40,
    fill: "#601a4a",
    className: "colore71868 svgShape",
    "data-name": "Rectangle 19011",
    transform: "translate(1272)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.428,19.424l7.741-7.747a1.457,1.457,0,0,1,2.066,0,1.475,1.475,0,0,1,0,2.072l-8.771,8.778a1.46,1.46,0,0,1-2.018.043L6.614,13.755a1.463,1.463,0,1,1,2.066-2.072Z",
    className: "colorfff svgShape",
    "data-name": "Icon ionic-ios-arrow-down",
    transform: "translate(1271.813 9.754)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.3cac7b4f92d2a99637d04ef06836932a.svg";
export { ForwardRef as ReactComponent };